import { useContext } from "react";
import { EmailActionContext } from "./EmailActionContext";

function usePrepareEmail() {
  const { setElementId, setShowModal } = useContext(EmailActionContext);
  return (id: any) => {
    setElementId(id);
    setShowModal(true);
  };
}

export default usePrepareEmail;
